import React, { useState, useEffect } from "react"
import "./SimpleTablePreview.scss"
import useProtocolTableArmsStore from "../../../../hooks/stores/useProtocolTableArmsStore"
import { v4 as uuidv4 } from "uuid"

const ArmsInterventionsPreview = (props) => {
  let { formContext } = props
  let { formData } = formContext
  const { setArms, setInterventions } = useProtocolTableArmsStore()
  const [title, setTitle] = useState("Arms")
  const [tableData, setTableData] = useState([])

  const keys = props.id.split(".")
  const key = keys[keys.length - 1]

  const studyArms = formData?.protocol?.study_arms

  useEffect(() => {
    if (studyArms?.[key]) {
      let results = getAssignedInterventions()
      setTableData(results)
    }
  }, [studyArms?.[key]])

  useEffect(() => {
    if (formData?.protocol?.study_type) {
      let studyType = formData.protocol.study_type
      if (studyType === "Observational") {
        setTitle("Groups/Cohorts")
      } else {
        setTitle("Arms")
      }
    }
  }, [formData])

  const getAssignedInterventions = () => {
    if (studyArms?.arms && studyArms?.interventions && studyArms?.crossref?.arms) {
      let { arms, interventions, crossref } = studyArms
      setArms(arms)
      setInterventions(interventions)

      let results = arms?.map((arm) => {
        let intArr = []

        let foundArm = crossref.arms.find((item) => item.id === arm.id)
        if (foundArm) {
          foundArm.interventions.forEach((int) => {
            let foundItem = interventions.find((item) => item.id === int)
            if (foundItem) intArr.push({ ...foundItem })
          })
        }

        return {
          arm,
          interventions: intArr,
        }
      })

      return results
    }

    if (studyArms?.arms && !studyArms?.interventions) {
      let { arms } = studyArms

      let results = arms?.map((arm) => {
        return {
          arm,
          interventions: [],
        }
      })

      return results
    }
  }

  return (
    <div className="simple-table-preview">
      <thead>
        <th>{title}</th>
        <th>Assigned Interventions</th>
      </thead>
      <tbody>
        {tableData &&
          tableData?.map((arm, i) => (
            <tr key={uuidv4()}>
              <td style={{ width: "50%" }}>
                <div>
                  <p className="simple-table-preview-title">
                    {i + 1}. {arm.arm.type || `(Type)`}: {arm.arm.title || `(Title)`}
                  </p>
                  <p className="simple-table-preview-para">{arm.arm.description || `(Description)`}</p>
                </div>
              </td>
              <td style={{ width: "50%" }}>
                <div>
                  {arm?.interventions?.map((intervention, j) => (
                    <div
                      key={uuidv4()}
                      style={{ marginBottom: 24 }}
                    >
                      <p className="simple-table-preview-title">
                        {intervention.type || `(Type)`}: {intervention.name || `(Title)`}
                      </p>
                      <p className="simple-table-preview-para">{intervention.description || `(Description)`}</p>
                      <p className="simple-table-preview-para">
                        Other names:{" "}
                        {(intervention?.other_intervention_names?.length &&
                          intervention?.other_intervention_names.join(", ")) ||
                          `(Other Intervention Names)`}
                      </p>
                    </div>
                  ))}
                </div>
              </td>
            </tr>
          ))}
      </tbody>
    </div>
  )
}

export default ArmsInterventionsPreview
